import Link from "next/link";
import Image from "next/image";

export default function Footer() {
  const quickLinks = [
    { label: "About", href: "/about" },
    { label: "Specialisms", href: "/specialisms" },
    { label: "Sectors", href: "/sectors" },
    { label: "Impact", href: "/impact" },
  ];

  return (
    <footer className="border-t border-standard mt-auto">
      <div className="max-w-6xl mx-auto px-6 py-8 sm:py-12">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 items-start">
          {/* Logo & Tagline */}
          <div className="flex flex-col space-y-4">
            <Link href="/" className="flex items-center gap-3">
              <Image 
                src="/footerlogo.png" 
                alt="Luminar Consult Logo" 
                width={120} 
                height={40}
                className="object-contain"
              />
            </Link>
            <p className="body-md leading-relaxed">
              Turning potential into intelligent impact.
            </p>
            <Link 
              href="/terms"
              className="body-md hover:text-accentcolourteal transition-colors"
            >
              Legal Notice
            </Link>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col space-y-3">
            <h3 className="body-lg font-semibold text-text-primary mb-1">
              Quick Links
            </h3>
            <nav className="flex flex-col space-y-2">
              {quickLinks.map((link, i) => (
                <Link 
                  key={i} 
                  href={link.href} 
                  className="btn w-full px-4 py-2 flex items-center justify-start"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div className="flex flex-col space-y-3">
            <h3 className="body-lg font-semibold text-text-primary mb-1">
              Our Services
            </h3>
            <div className="flex flex-col space-y-2">
              <Link 
                href="/specialisms#customer-commercial"
                className="btn w-full px-4 py-2 flex items-center justify-start"
              >
                Customer & Commercial
              </Link>
              <Link 
                href="/specialisms#technology-platforms"
                className="btn w-full px-4 py-2 flex items-center justify-start"
              >
                Technology & Platforms
              </Link>
              <Link 
                href="/specialisms#data-ai"
                className="btn w-full px-4 py-2 flex items-center justify-start"
              >
                Data & AI
              </Link>
              <Link 
                href="/specialisms#people-change"
                className="btn w-full px-4 py-2 flex items-center justify-start"
              >
                People & Change
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div className="flex flex-col space-y-3">
            <h3 className="body-lg font-semibold text-text-primary mb-1">
              Contact
            </h3>
            <div className="flex flex-col space-y-2">
              <a 
                href="mailto:contact@luminarconsult.com"
                className="body-md hover:text-accentcolourteal transition-colors"
              >
                contact@luminarconsult.com
              </a>
              <p className="body-md">
                Poole, United Kingdom
              </p>
              <p className="body-md mt-4">
                Company No. 15785074
              </p>
            </div>

            {/* LinkedIn */}
            <div className="pt-4">
              <a 
                href="https://www.linkedin.com/company/luminar-consult"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 hover:opacity-80 transition-opacity"
                aria-label="Visit our LinkedIn profile"
              >
                <svg 
                  className="w-8 h-8" 
                  fill="currentColor" 
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 sm:mt-4 sm:pt-2 border-t border-standard flex items-center justify-center">
          <p className="body-md text-center">
            © {new Date().getFullYear()} Luminar Consult. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}